<template>
  <div class="homelistmsg">
    <div class="topfixed-wrap">{{listptitle}}</div>
    <h3 class="articletit">{{listtitle}}</h3>
    <div class="content-tit clearfix">
        <div class="lf icons">
            <img src="../../assets/images/introduction.png">
        </div>
        <div class="lf txtdescript">
            <p class="production-txt">产品概述</p>
            <p class="introduction-txt">Introduction</p>
        </div>
    </div>
    <p class="content-p">{{description}}</p>
    <div class="content-tit clearfix" style="display:none">
        <div class="lf icons">
            <img src="../../assets/images/pf.png">
        </div>
        <div class="lf txtdescript">
            <p class="production-txt">产品特点</p>
            <p class="introduction-txt">Product Function</p>
        </div>
    </div>

    <p style="display:none" class="content-p">{{special}}</p>

      <div class="allSort">
       <div class="sortMenu clearfix">
          <ul class="sortMenu-ul" >
            <li class="cell"  v-for="(item,index) in navtit" :key="index" :primary=item.primary  @click="changemsg(index,$event)">
              {{item.psname}}
            </li>
          </ul>
       </div>
      </div>
<!-- =======    <div id="wrapper">   -->

            <!-- <ul id="title_ul">
                <li v-for="(item,index) in navtit" :key="index" :primary=item.primary  @click="changemsg(index,$event)">{{item.psname}}</li>
            </ul>   -->
            <!-- <div class="swiper-container swiper1" >
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in navtit" :key="index" :primary=item.primary  @click="changemsg(index,$event)">{{item.psname}}</div>
              </div>

            </div> -->
        </div>
</template>

<script>
// import "../../assets/js/iscroll.js";

import config from "../../assets/js/config.js";
import "../../assets/css/swiper.min.css"
import "../../assets/js/swiper.js"

export default {
  name: "yfyjsMore",
  data() {
    return {
      listptitle: "",
      listtitle: "",
      navtit: [],
      description: "",
      special: ""
      //   listptitle: this.$store.state.listmsgs[0].productSystem.psname,
      //   listtitle: this.$store.state.listmsgs[0].childs[0].psname
    };
  },
  computed: {
    // listmsgss(){
    //     return this.$store.state.listmsgs
    // }
  },
  mounted() {
    this.arguments();
    // this.navfn();


  },
  created(){
      // var ulEle=$('#title_ul'),
      //    aLiEle=ulEle.find('li');
      //    alert(aLiEle.length)
      // aLiEle.bind('click',function(){
      //   alert(1)
      // });
  },
  methods: {
//     navfn(){

//       new Swiper('.swiper1', {
// //					设置slider容器能够同时显示的slides数量(carousel模式)。
// //					可以设置为number或者 'auto'则自动根据slides的宽度来设定数量。
// //					loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
// 					slidesPerView: 5.5,
// 					paginationClickable: false,//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
// 					spaceBetween: 10,//slide之间的距离（单位px）。

// 					freeMode: true,//默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
//           loop: false,//是否可循环

// 					freeMode: false,//默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
// 					loop: false,//是否可循环

// 					// onTab: function(swiper) {
// 					// 	var n = swiper1.clickedIndex;
// 					// }
// 				});
//     },
    arguments() {
      var that = this;
      var urlprimary = this.$store.state.changedata;
      that.$ajax.post(config.homePage.msgList,JSON.stringify({"pid":urlprimary})).then(function(response) {
        that.listptitle = response.data.data.productSystem.psname;
        that.listtitle = response.data.data.childs[0].psname;
        that.navtit = response.data.data.childs;
        that.description = response.data.data.productSystem.subdescription;
        // that.special = response.data.data.productSystem.subdescription;
      });
    },
    changemsg(index,event) {
      var that = this;
      event.cancelBubble = true;
      let numbers = event.target.attributes.primary.nodeValue;
      that.$ajax.post(config.homePage.listmsg,JSON.stringify({"primary":numbers})).then(function(response) {
        that.listtitle = response.data.data.productSystem.psname;
        that.description = response.data.data.productSystem.subdescription;
      });
    }
  }
};
</script>
<style scoped>
.sortMenu{
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-x: scroll;
  margin-top: .3rem
}
.sortMenu::-webkit-scrollbar{
  width: 0;
  height: 0;
  background-color: #fff;
}
.sortMenu-ul {
  min-width:500px;
  display: flex;
  justify-content: flex-start;
}
.sortMenu .cell{
  display: inline-block;
  text-align: center;
  position: relative;
  text-overflow: ellipsis;
  word-break: keep-all;
  align-items: center;
	cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  background-color: #3c3c3c;
  color: #fff;
  margin-right: 0.12rem;
  font-size: 0.24rem;
  border-radius: 10px;
  padding: 0 .2rem
}

.sortMenu .cell.special:before {
  content: '';
  height: 2px;
  width: 100%;
  background: #ff474c;
  position: absolute;
  bottom: 0px;
}
.topfixed-wrap {
  height: 0.57rem;
  line-height: 0.57rem;
  width: 100%;
  background: rgb(73, 73, 73);
  z-index: 3;
  color: #fff;
  font-size: 0.34rem;
}
.txtdescript {
  margin-left: 0.12rem;
}
.articletit {
  font-size: 0.32rem;
  color: #40a4e7;
  padding: 0.22rem 0 0.57rem 0;
}
.icons {
  width: 0.75rem;
  height: 0.75rem;
}
.content-tit {
  margin-left: 35%;
  text-align: left;
}
.icons img {
  width: 100%;
}
.production-txt {
  font-size: 0.24rem;
  font-weight: 600;
  padding-top: 0.1rem;
}
.introduction-txt {
  font-size: 0.2rem;
}
.content-p {
  font-size: 0.22rem;
  padding-bottom: 0.6rem;
  width: 88%;
  margin: 0 auto;
  line-height: 0.38rem;
  margin-top: 0.18rem;
  color: #696969;
  text-indent: 0.2rem;
  text-align: left;
}
.allSort {
  position: absolute;
  z-index: 1;
  bottom: 1rem;
  height: 1.05rem;
  left: 0;
  width: 100%;
  background: #262626;
  overflow: hidden;
}

 #scroller {
  position: absolute;
  z-index: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  height: 100%;
  text-size-adjust: none;
}


.swiper-wrapper {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  margin-top: 0.3rem;
}

.swiper-wrapper .swiper-slide {
  display: block;
  float: left;

  height: 0.4rem;
  line-height: 0.4rem;
  background-color: #3c3c3c;
  color: #fff;
  margin-right: 0.12rem;
  font-size: 0.24rem;
  border-radius: 10px;
}



</style>



// WEBPACK FOOTER //
// src/components/homePage/listmsg.vue